import * as React from 'react';
import DispatchProps from '../../application/core/DispatchProps';

class Admin extends React.PureComponent<DispatchProps> {
    public render(): JSX.Element | null {
        return null;
    }
}
export default Admin;



// WEBPACK FOOTER //
// ./src/view/admin/Admin.tsx